import { render } from "./GatewayUpdateFirmwareModal.vue?vue&type=template&id=4ec1a21c"
import script from "./GatewayUpdateFirmwareModal.vue?vue&type=script&lang=js"
export * from "./GatewayUpdateFirmwareModal.vue?vue&type=script&lang=js"
script.render = render

export default script